import React from 'react'
import cn from 'classnames'
import { Button, Input, InputRef } from 'antd'
import { t } from '../../../config/i18n'
import styles from './InputAdd.module.scss'

interface Props {
  className?: string
  disabled?: boolean
  value?: string[]
  placeholder?: string
  validate?: (value: string) => boolean
  onChange?: (value: string[]) => void
}

export const InputAdd = ({ className, disabled, value = [], placeholder, validate, onChange = () => {} }: Props) => {
  const inputRef = React.useRef<InputRef>(null)
  const [val, setVal] = React.useState('')
  const [toValidate, setToValidate] = React.useState(false)
  const [error, setError] = React.useState(false)

  const addValue = React.useCallback(() => {
    if (val && !disabled) {
      if (validate && !validate(val)) {
        setError(true)
        setToValidate(true)
      } else {
        onChange([...new Set([...value, val])])
        setVal('')
        setError(false)
        setToValidate(false)
      }
    }
  }, [val, disabled, value, onChange])

  const handleChange = React.useCallback((v: string) => {
    setVal(v)
    if (toValidate && validate) {
      setError(!validate(v))
    }
  }, [toValidate, validate])

  const handleEnter = React.useCallback((e: React.KeyboardEvent) => {
    e.preventDefault()
    addValue()
    setTimeout(() => inputRef.current?.focus(), 10)
  }, [addValue, inputRef.current])

  return (
    <Input.Group compact className={cn(styles.root, className)}>
      <Input
        ref={inputRef}
        value={val}
        placeholder={placeholder}
        status={error ? 'error' : undefined}
        onChange={e => handleChange(e.target.value)}
        onPressEnter={handleEnter}
      />
      <Button
        tabIndex={-1}
        onClick={addValue}
      >
        {t.common.add}
      </Button>
    </Input.Group>
  )
}
